import initHelpHero from 'helphero'

export const helpHero = initHelpHero(process.env.REACT_APP_HELPHERO_API_KEY)
